<script>
  import http from '@/service/http'
  import { ListSelect } from 'vue-search-select'
  import { mapState } from 'vuex'
  import filter from 'lodash/filter'

  export default {
    name: 'Form',
    components: {
      ListSelect
    },
    data () {
      return {
        produtos: [],
        produtosSearch: [],
        familias: [],
        contas: [],
        canais: [],
        familia_id: '',
        venda: {
          id: '',
          venda: '',
          desconto: 0,
          canal_id: '',
          produtos: [],
          pagamentos: []
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      },
      valor_total () {
        this.venda.valor = this.valor_total
      },
      familia_id () {
        if (this.familia_id) {
          this.produtosSearch = filter(this.produtos, { 'familia_id': this.familia_id })
        } else {
          this.produtosSearch = this.produtos
        }
      }
    },
    methods: {
      validate: function () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/vendas' : `/vendas/${this.venda.id}`
        const {data} = await http[verb](url, this.venda)
        if (data != null) {
          this.$emit('update-vendas-list', {venda: data.venda})
          this.$router.push({name: 'vendas.index'})
        }
      },
      async fecth () {
        this.clear()
        const { id } = this.$route.params
        if (id !== undefined) {
          const { data } = await http.get(`/vendas/${id}/edit`)
          this.venda = data.venda
          this.produtos = data.produtos
          this.produtosSearch = data.produtos
          this.familias = data.familias
          this.contas = data.contas
          this.canais = data.canais
        } else {
          const { data } = await http.get(`/vendas/create`)
          this.produtos = data.produtos
          this.produtosSearch = data.produtos
          this.familias = data.familias
          this.contas = data.contas
          this.canais = data.canais
        }
        setTimeout(function () {
          $('select').material_select()
          window.Materialize.updateTextFields()
        }, 0)
      },
      clear () {
        this.venda = {
          id: '',
          venda: '',
          desconto: 0,
          canal_id: '',
          produtos: [],
          pagamentos: []
        }
      },
      onSelectProduto (item) {
        if (item) {
          const produto = {
            produto_id: item.id,
            produto: item,
            valor: item.valor_venda,
            qtd: 1
          }
          this.addProduto(produto)
        }
      },
      async addProduto (produto) {
        if (typeof this.venda.produtos === 'undefined') {
          this.venda.produtos = []
        }
        await this.venda.produtos.push(produto)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      destroyProduto (indexProduto) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um Produto é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.venda.produtos[indexProduto].id) {
            this.venda.produtos.splice(indexProduto, 1)
            window.Materialize.toast('Produto excluído!', 4000)
          } else {
            http.delete(`vendas/produto/${this.venda.produtos[indexProduto].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Produto excluído!', 4000)
                this.venda.produtos.splice(indexProduto, 1)
              })
          }
        })
      },
      destroyPagamento (index) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um forma de pagamento é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          this.venda.pagamentos.splice(index, 1)
          window.Materialize.toast('Pagamento excluído!', 4000)
        })
      },
      addPagamento () {
        const pagamento = {
          forma_id: '',
          conta_id: '',
          valor: parseFloat((this.valor_total - this.pagamentoTotal)).toFixed(2),
          parcelas: 1
        }
        this.venda.pagamentos.push(pagamento)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.venda.id === ''
      },
      valor_total () {
        let valor = 0
        let desconto = this.venda.desconto ? this.venda.desconto : 0
        this.venda.produtos.forEach(function (produto) {
          valor += parseFloat(produto.valor) * parseInt(produto.qtd)
        })
        return parseFloat(parseFloat(valor).toFixed(2) - parseFloat(desconto).toFixed(2)).toFixed(2)
      },
      pagamentoTotal () {
        let valor = 0
        if (this.venda.pagamentos.length > 0) {
          this.venda.pagamentos.forEach((item) => {
            if (item.valor) {
              valor += parseFloat(item.valor)
            }
          })
        }
        return parseFloat(valor).toFixed(2)
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12">

          <div>

            <div class="row">

              <div class="input-field col s12 m8">

                <div class="row">

                  <div class="input-field col s12">
                    <select :disabled="!isNew" :name="`canal_id`" :id="`canal_id`" class="browser-default" v-model="venda.canal_id" v-validate data-vv-rules="required" :class="{invalid: errors.has('canal_id')}">
                      <option value="">Canal de Venda</option>
                      <option v-for="canal in canais" :value="canal.id">{{ canal.canal }}</option>
                    </select>
                    <small class="red-text">{{ errors.first('canal_id') }}</small>
                  </div>

                </div>

                <div class="row" v-show="isNew" >

                  <div class="input-field col s12">
                    <select :name="`familia_id`" :id="`familia_id`" class="browser-default" v-model="familia_id">
                      <option value="">Família</option>
                      <option v-for="familia in familias" :value="familia.id">{{ familia.familia }}</option>
                    </select>
                  </div>

                </div>

                <div class="row" v-show="isNew">
                  <div class="input-field col s12">
                    <list-select :list="produtosSearch"
                                 option-value="id"
                                 option-text="produto"
                                 placeholder="Adicionar Produto"
                                 @select="onSelectProduto">
                    </list-select>
                  </div>
                </div>

                <div class="row" v-show="venda.produtos && venda.produtos.length > 0">
                  <div class="col s12">
                    <table class="responsive-table bordered highlight">
                      <tr>
                        <th>Produtos </th>
                        <th>Qtd</th>
                        <th>Valor</th>
                        <th>Valor Total</th>
                        <th class="right-align" v-show="isNew">Excluir</th>
                      </tr>
                      <tr v-for="(produto, indexProduto) in venda.produtos">
                        <td>
                          <p>{{ (produto.produto) ? produto.produto.produto : '-' }}</p>
                        </td>
                        <td>
                          <input v-if="!produto.hasOwnProperty('id')" type="number" :id="`qtdProduto${indexProduto}`" v-model="produto.qtd" min="1" style="margin-bottom: 0">
                          <input v-else type="number" :id="`qtdProduto${indexProduto}`" v-model="produto.qtd" min="1" style="margin-bottom: 0" readonly>
                        </td>
                        <td>
                          <input v-if="!produto.hasOwnProperty('id')"  type="number" step="any" :id="`valorProduto${indexProduto}`" v-model="produto.valor" min="1" style="margin-bottom: 0">
                          <input v-else  type="number" step="any" :id="`valorProduto${indexProduto}`" v-model="produto.valor" min="1" style="margin-bottom: 0" readonly>
                        </td>
                        <td>
                          <input type="number" step="any" :id="`valorTotalProduto${indexProduto}`" :value="parseFloat(produto.valor * produto.qtd).toFixed(2)" style="margin-bottom: 0" readonly>
                        </td>
                        <td v-show="isNew">
                          <div class="right-align">
                            <a href="#" @click.prevent="destroyProduto(indexProduto)">
                              <i class="material-icons red-text">delete_forever</i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <input name="valor" id="valor" type="hidden" v-model="venda.valor">
                  </div>
                </div>

              </div>
              <div class="input-field col s12 m4">
                <p>Total Venda</p>
                <h2>R$ {{ venda.valor ? venda.valor : '0,00' }}</h2>

                <br />

                <div class="row z-depth-1" v-show="venda.produtos.length">
                  <div class="input-field col s12">
                    <input :disabled="!isNew" type="number" step="0.01" name="desconto" id="desconto" v-model="venda.desconto" v-validate data-vv-rules="required" :class="{invalid: errors.has('desconto')}">
                    <label for="`desconto`">Desconto</label>
                  </div>
                </div>

                <div class="row z-depth-1" v-for="(pagamento, index) in venda.pagamentos">

                  <div class="input-field col s12 m6">
                    <select :disabled="!isNew" :name="`forma${index}`" :id="`forma{index}`" class="browser-default" v-model="pagamento.forma_id" v-validate data-vv-rules="required" :class="{invalid: errors.has('forma' + index)}">
                      <option value="">Forma de Pagamento</option>
                      <option :value="1">Dinheiro</option>
                      <option :value="2">Crédito</option>
                      <option :value="3">Débito</option>
                      <option :value="4">Cheque</option>
                      <option :value="5">Transferência</option>
                      <option :value="6">Boleto</option>
                    </select>
                    <small class="red-text">{{ errors.first('forma'+index) }}</small>
                  </div>

                  <div class="input-field col s12 m6">
                    <input :disabled="!isNew" type="number" step="any" :name="`valor${index}`" :id="`valor${index}`" v-model="pagamento.valor" v-validate data-vv-rules="required" :class="{invalid: errors.has('valor' + index)}">
                    <label :for="`valor${index}`">Valor</label>
                    <small class="red-text">{{ errors.first('valor'+index) }}</small>
                  </div>

                  <div class="input-field col s12 m6">
                    <select :disabled="!isNew" :name="`conta${index}`" :id="`conta{index}`" class="browser-default" v-model="pagamento.conta_id" v-validate data-vv-rules="required" :class="{invalid: errors.has('conta' + index)}">
                      <option value="">Conta Bancária</option>
                      <option v-for="conta in contas" :value="conta.id">{{ conta.conta }}</option>
                    </select>
                    <small class="red-text">{{ errors.first('conta'+index) }}</small>
                  </div>

                  <div class="input-field col s12 m6">
                    <input :disabled="!isNew" v-if="pagamento.forma_id !== 1 && pagamento.forma_id !== 3 && pagamento.forma_id !== 5" type="number" min="1" :name="`parcelas${index}`" :id="`parcelas${index}`" v-model="pagamento.parcelas" v-validate data-vv-rules="required" :class="{invalid: errors.has('parcelas' + index)}">
                    <input v-if="pagamento.forma_id === 1 || pagamento.forma_id === 3 || pagamento.forma_id === 5" readonly type="number" :name="`parcelas${index}`" :id="`parcelas${index}`" v-model="pagamento.parcelas" value="1">
                    <label :for="`parcelas${index}`">N. Parcelas</label>
                    <small class="red-text">{{ errors.first('parcelas'+index) }}</small>
                  </div>

                  <div class="col s12 right-align" v-show="isNew">
                    <i class="pointer material-icons red-text" @click.prevent="destroyPagamento(index)">delete_forever</i>
                  </div>

                </div>

                <br />

                <div class="row" v-show="parseFloat(valor_total) !== parseFloat(pagamentoTotal)">

                  <div class="input-field col s12">
                    <span class="red-text">Valor total das parcelas <strong>R$ {{ parseFloat(pagamentoTotal).toFixed(2) }}</strong> não corresponde com o valor da Venda <strong>R$ {{ parseFloat(valor_total).toFixed(2) }}</strong></span>
                  </div>

                </div>

                <div class="row" v-if="parseFloat(valor_total) > pagamentoTotal">
                  <div class="col s12">
                    <button class="waves-effect waves-light btn" @click.prevent="addPagamento">Adicionar Forma de Pagamento</button>
                  </div>
                </div>

                <div class="row" v-show="isNew">
                  <div class="col s12">
                    <button class="waves-effect waves-light btn" :disabled="parseFloat(valor_total) !== parseFloat(pagamentoTotal)">Salvar</button>
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/vendas/vendas/form.vue